import { render, staticRenderFns } from "./sys-user-org.vue?vue&type=template&id=766e4fd8&scoped=true&"
import script from "./sys-user-org.vue?vue&type=script&lang=js&"
export * from "./sys-user-org.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766e4fd8",
  null
  
)

export default component.exports